import eventBus from 'pubsub-js';

// we use the event bus because the loading animation is displayed in an angularjs component and if we listen to the service directly it doesn't automatically update the animation ($scope.watch doesnt work)
function setSmallLoadingAnimation(value) {
  eventBus.publish('showLoadingAnimationChanged', value);
}

function showSmallLoadingAnimation() {
  eventBus.publish('showLoadingAnimationChanged', true);
}

function hideSmallLoadingAnimation() {
  eventBus.publish('showLoadingAnimationChanged', false);
}

export default {
  setSmallLoadingAnimation,
  showSmallLoadingAnimation,
  hideSmallLoadingAnimation,
};
